import { Button, withStyles } from '@material-ui/core'

const BottomFullButtonStandalone = withStyles((theme) => ({
    root: {
        width: '100%',
        borderRadius: 0,
        border: 0,
        padding: 0,
        backgroundColor: '#202122',
        transition: 'none',

        '&:hover': {
            border: 0,
            background: '#F9CC04',
        },
    },

    label: {
        color: '#F9CC04',
        padding: '10px',
        borderTop: '1px solid #3F3F3F',

        '&:hover': {
            color: '#202122',
            borderTop: '1px solid #3F3F3F',
        },

        '&::placeholder': {
            color: 'transparent',
        },
    },
}))(Button)

export default BottomFullButtonStandalone
